module.exports = "/wp-content/plugins/farmacy/assets/js/images/bag-icon-dcfc1eae6884dc8208184fcebbec1816.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/cart/shopping-cart-indicator/img/bag-icon.png
 ** module id = 398
 ** module chunks = 1 27 28 80 143
 **/